// 11th month is December (zero-based count), 3 hours is offset from UTC for Moscow time
export const ACTION_START_TIME_UTC: Date = new Date(Date.UTC(2022, 11, 7, 11 - 3));
